import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Status from '../React/Status';
import Button from '../button/Button';
import HeaderTags from '../headerTags/HeaderTags';

/*
*This is a custom error page.
*It takes a title and (maybe later) other stuff that additionally will be rendered if given
*Used for example on single News and single artists
*/

const ErrorPage = (props) => {
    let metaTitle = 'Algo deu ruim :(';

    if (props.errorNumber === 404) {
        metaTitle = 'Pagina não encontrada';
    } else if (props.errorNumber === 500) {
        metaTitle = 'Erro do servidor';
    }

    return (
        <Status code={props.errorNumber}>
            <div>
                <HeaderTags title={metaTitle} />
                <section>
                    <div className="error">
                        <div className="errorDescription">
                            <h2>
                                {props.title}
                            </h2>
                            <p>
                                {props.message}
                            </p>
                            <div className="btnGoBack">
                                <Button to={props.backLink} title={props.buttonText}>
                                    {props.buttonText}
                                </Button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Status>
    );
};

ErrorPage.propTypes = exact({
    errorNumber: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    backLink: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
});

export default ErrorPage;
